import { FTProcess } from '@/models/FTProcess';
import { weightToPieces, shapeArea, initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index'
import { ConversionDetails } from '@/models/ConversionDetails';
import _ from 'lodash';
import { FTProcessRow } from '@/models/FTProcessRow';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    inputs: {
      goods: [
        {
          goodsType: '',
          goodsFilter: {
            form: ['sheet', 'die-cut-sheet', 'cup-formed'], 
          },
          multiple: true,
          addMultipleButtonText: 'add more input goods(Tray Cups Orders)',
          params: [
            {
              name: 'Shape',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.shape', ''),
              disabled: true
            },
            {
              name: 'Width',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.width', ''),
              unit: 'mm',
              showIf: ['Oval', 'Rectangle', 'Rectangle+Oval'].includes(_.get(processRow, 'dimensions.shape')),
              disabled: true
            },
            {
              name: 'Length',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.length', ''),
              unit: 'mm',
              showIf: ['Oval', 'Rectangle', 'Rectangle+Oval'].includes(_.get(processRow, 'dimensions.shape')),
              disabled: true
            },
            {
              name: 'Diameter',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.diameter', ''),
              unit: 'mm',
              showIf: _.get(processRow, 'dimensions.shape') === 'Round',
              disabled: true
            },
            {
              name: 'Area',
              type: 'label',
              value: _.get(processRow, 'goodsObject.dimensions.area', ''),
              unit: 'sq. mm',
              showIf: _.get(processRow, 'dimensions.shape') === 'Other',
              disabled: true
            },
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'single',
      arguments: [
        {
          name: 'Height',
          type: 'label',
          value: _.get(processRow, 'ftProcess.ftFactoryTicket.order.product.size.HEIGHT', ''),
          unit: 'mm',
          disabled: true
        },
        {
          name: 'Number of Teeth',
          type: 'label',
          value: _.get(processRow, 'ftProcess.ftFactoryTicket.order.product.size.HEIGHT', ''),
          disabled: true
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Piece(s) per stroke',
        value: 'pcsPerStroke'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'No of Pieces',
        value: 'numberOfPieces'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}


export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);

  let formedPiecesEstimate = 0, netWeight = 0;
  conversionResult.details.totalQuantity = 0;
  const processInputRow = process.inputs[0];
  const outputFTProcessRow = process.outputs[0];

  formedPiecesEstimate = weightToPieces(processInputRow.quantity, processInputRow.goodsObject.density, shapeArea({
    shape: processInputRow.goodsObject.dimensions && processInputRow.goodsObject.dimensions.shape,
    params: processInputRow.goodsObject.dimensions
  }));
  outputFTProcessRow.goodsObject.copyFrom(process.inputs[0].goodsObject);
  outputFTProcessRow.goodsObject.form = 'cup-formed';
  _.mapValues(process.inputs, (processInputRow: FTProcessRow) => {
    netWeight += (processInputRow.quantity || 0);
  });
  const value = netWeight ? formedPiecesEstimate / netWeight : 0;
  outputFTProcessRow.goodsObject.setPerKgRatio('plA', value);
  conversionResult.outputs[0] = outputFTProcessRow;

  conversionResult.details.numberOfPieces = formedPiecesEstimate;
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.netWeight = netWeight;
  conversionResult.details.kgPerHour = 60 * processInputRow.goodsObject.unitWeight * process.machineDetail.mechanicalSpeed * (process.machineDetail.pcsPerStroke || 0);
  conversionResult.details.plannedHours = (conversionResult.details.numberOfPieces * conversionResult.outputs[0].goodsObject.unitWeight) / conversionResult.details.kgPerHour;
  conversionResult.details.pcsPerStroke = process.machineDetail.pcsPerStroke;

  return conversionResult;
}